import { UseFormReturn } from 'react-hook-form'
import { useCallback } from 'react'
import { setMeresIsVisibleIndex } from '@services/riskMapModal'
import { useAppSelector } from '@hooks/useAppSelector'
import { useLazyGetDangersSearchedMeresQuery } from '@services/dangers'
import {
  getDangerHazardName,
  getEventName,
} from '@modals/RiskMapModal/Dangers/nameUtils'
import { Option } from '@organisms/Select'
import { useAppDispatch } from '@hooks/useAppDispatch'

const useMeresModal = ({ watch }: UseFormReturn, index: number) => {
  const dispatch = useAppDispatch()

  const meresState = useAppSelector(
    (state) => state.riskMapModal.selectedMeresForms[index]
  )

  const [getDangersSearchedMeres, { isLoading: meresIsLoading }] =
    useLazyGetDangersSearchedMeresQuery()

  const dangersControlMeasureWorkplace: 'office' | null = watch(
    'dangersControlMeasureWorkplace'
  )?.value

  const hazard: Option | undefined = watch(getDangerHazardName(index))
  const event: Option | undefined = watch(getEventName(index))

  const openMeres = useCallback(async () => {
    if (!meresState?.prefilled) {
      await getDangersSearchedMeres({
        hazard: hazard?.value,
        event: event?.value,
        modalIndex: index,
        dangersControlMeasureWorkplace,
      })
    }

    setTimeout(() => {
      dispatch(setMeresIsVisibleIndex(index))
    }, 600)
  }, [
    dangersControlMeasureWorkplace,
    dispatch,
    event?.value,
    getDangersSearchedMeres,
    hazard?.value,
    index,
    meresState?.prefilled,
  ])

  const closeMeres = useCallback(() => {
    dispatch(setMeresIsVisibleIndex(null))
  }, [dispatch])

  return {
    openMeres,
    closeMeres,
    meresIsLoading,
  }
}

export default useMeresModal
